


















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  saveServiceTaskType,
  SaveServiceTaskTypeCommand
} from "@/servicetask/api/service-tasks-api";
import { cloneDeep } from "lodash";

@Component({ components: {} })
export default class ServiceTasksForm extends Vue {
  @Prop({ type: Object }) defaultValues?: SaveServiceTaskTypeCommand;

  values: SaveServiceTaskTypeCommand = {
    id: "",
    name: ""
  };

  // 値を引き継ぐ
  @Watch("defaultValues", { immediate: true })
  onDefaultValuesChanged(values: SaveServiceTaskTypeCommand) {
    if (!values) {
      return;
    }
    this.values = cloneDeep(values);
  }

  // APIへ保存する値を渡す
  public async submit() {
    await saveServiceTaskType(this.values);
    this.$emit("submit");
    this.$store.dispatch("initServiceTaskTypes");
  }
}
